export const links = [
    {
        "nombre" : "Transparencia",
        "link" : "/Transparencia",
        "submenu" : [
            {
                "subMenuNombre" : "48 Rubros",
                "subMenuUrl" : "/Transparencia/Rubros"
            },
            {
                "subMenuNombre" : "Art. 70 Ley de Transparencia",
                "subMenuUrl" : "/Art70"
            },
            {
                "subMenuNombre" : "Rubros Anteriores",
                "subMenuUrl" : "/Transparencia/Rubros/RubrosHistoricos"
            },
            {
                "subMenuNombre" : "COCODI",
                "subMenuUrl" : "/Cocodi"
            },
            {
                "subMenuNombre" : "Sistema Institucional de Archivos",
                "subMenuUrl" : "/SistemaInstitucionalArchivos"
            },
        ]
    },
    {
        "nombre" : "Servicios",        
        "link" : "/Servicios",
        "submenu" : [
            {
                "subMenuNombre" : "Banda Sinfónica del Estado de Hidalgo",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/529"
            },
            {
                "subMenuNombre" : "Renta de espacios culturales",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/473"
            },
            {
                "subMenuNombre" : "Taquilla Cultural",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/8035"
            },
            {
                "subMenuNombre" : "Tienda Margarita Michelena.",
                "subMenuUrl" : "https://tienda.cecultah.gob.mx/"
            },
            {
                "subMenuNombre" : "Encuesta de Satisfacción de Servicios del CECULTAH",
                "subMenuUrl" : "https://docs.google.com/forms/d/e/1FAIpQLSeIvIpq3z97rSjhFbJxTKqAMf42x0OGsUSbvN5H4xH-nx-xPg/viewform"
            },
            {
                "subMenuNombre" : "Evaluación de comunicación externa",
                "subMenuUrl" : "https://forms.gle/CticwEEwj5ZBkP4o8"
            },
        ]
    },
    {
        "nombre" : "Trámites",
        "link" : "/Tramites",
        "submenu" : [
            {
                "subMenuNombre" : "Cursos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/12007"
            },
            {
                "subMenuNombre" : "Programa Escolarizado de Educación Artística Inicial del Centro de las Artes de Hidalgo",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/11887"
            },
            {
                "subMenuNombre" : "Cursos escolarizados y talleres artísticos impartidos en Unidades de Educación Artística y Centros Culturales Regionales",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/566"
            },
            {
                "subMenuNombre" : "Becas para alumnado del Programa Estatal de Educación Artística del CECULTAH",
                "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/7059"
            },
               {
                "subMenuNombre" : "Talleres Artisticos especializados del Centro de las Artes de Hidalgo",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/585"
            },
               {
                "subMenuNombre" : "Talleres artísticos  impartidos en el Centro de las Artes de Hidalgo",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/583"
            },
               {
                "subMenuNombre" : "Cursos de verano en la Unidades de Educación Artística",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/12005"
            },
               {
                "subMenuNombre" : "Expedición de credencial en Centro de las Artes y Centros Culturales Regionales",
                 "subMenuUrl" : "https://ruts.hidalgo.gob.mx/ver/12006"
            },
             {
                "subMenuNombre" : "Encuesta de Satisfacción de Tramites del CECULTAH",
                "subMenuUrl" : "https://docs.google.com/forms/d/e/1FAIpQLSeIvIpq3z97rSjhFbJxTKqAMf42x0OGsUSbvN5H4xH-nx-xPg/viewform"
            },
             {
                "subMenuNombre" : "Evaluación de comunicación externa",
                "subMenuUrl" : "https://forms.gle/CticwEEwj5ZBkP4o8"
            },
        ]
    },
    {
          "nombre" : "Adquisiciones",
          "link" : "/Adquisiciones",
          "submenu" : [
            {
               "subMenuNombre" : "PAAAS CECULTAH",
                "subMenuUrl" : "/Paaas",
            },
            {
               "subMenuNombre" : "Licitaciones Públicas Nacionales",
                "subMenuUrl" : "/Licitaciones",
            },
            {
               "subMenuNombre" : "Invitacion a cuando menos tres personas",
               "subMenuUrl" : "/Invitacion",
            },
            {
               "subMenuNombre" : "Ejercicios Anteriores",
                "subMenuUrl" : "/EjerciciosAnteriores",
               
            },
        ]
    },
    {
        "nombre" : "Convocatorias",
        "link" : "/Convocatorias",   
    },
     {
    "nombre": "Transparencia Proactiva",
    "link": "/Map_Hidalgo/",
    "esExterno": true,
    "submenu": [],
    "target": "_self"
},
    {
          "nombre" : "Armonización Contable",
          "link" : "/Armonizacion",
          "submenu" : [
            
        ]
    },
    {
          "nombre" : "Normatividad",
          "link" : "/Normatividad",
          "submenu" : [
            
        ]
    },
     {
        "nombre" : "Quejas y Denuncias",
        "link" : "https://docs.google.com/forms/d/e/1FAIpQLSeGq2PU7f91SAf4YXZDfiGbHVleT2wxGgjfyF8Eqwac7dhsLA/viewform",
       
    },
   
]